module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    attrs: {
      "id": "home-1"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("铿锵侠")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("一个目前在帝都的GISer。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "width": "300px",
      "text-align": "center",
      "margin": "0 auto"
    }
  }, [_vm._v("程序员里地图画的很好，画地图里文章写得很棒，写文章里编程编的不错。就是这么一个人。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "30px"
    }
  }, [_c('div', {
    attrs: {
      "id": "home-pic-1"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "知乎主页",
      "placement": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": "https://www.zhihu.com/people/kengqiangxia",
      "target": "_blank"
    }
  }, [_vm._v("铿锵侠")])]), _vm._v(" "), _c('div', [_vm._v("知乎专栏")])], 1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "科普为主，适合所有人阅读",
      "placement": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": "https://zhuanlan.zhihu.com/mapworld",
      "target": "_blank"
    }
  }, [_vm._v("《地图看世界》")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "技术为主，适合GIS初学者阅读",
      "placement": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": "https://zhuanlan.zhihu.com/GISDevelop",
      "target": "_blank"
    }
  }, [_vm._v("《GIS开发从入门到放弃》")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "content": "欢迎扫描二维码，添加关注",
      "placement": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "color": "#2d8cf0",
      "cursor": "pointer",
      "width": "100px",
      "text-align": "center"
    },
    on: {
      "click": _vm.toMapView
    }
  }, [_vm._v("mapsworld")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "30px"
    }
  }, [_c('div', [_c('Icon', {
    attrs: {
      "type": "map"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("地图应用")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "color": "#2d8cf0",
      "cursor": "pointer",
      "width": "100px",
      "text-align": "center"
    },
    on: {
      "click": _vm.toMapView
    }
  }, [_vm._v("地图列表")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": "https://shop113148564.taobao.com",
      "target": "_blank"
    }
  }, [_vm._v("地图看世界周边")])], 1), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "home-cartoon"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("知乎主页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "30px"
    }
  }, [_c('div', {
    attrs: {
      "id": "home-pic-3"
    }
  }), _vm._v(" "), _c('span', [_vm._v("微信公众号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "16px",
      "margin-top": "30px"
    }
  }, [_c('div', {
    attrs: {
      "id": "home-pic-2"
    }
  }), _vm._v(" "), _c('span', [_vm._v("淘宝店")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d62ce86","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 69
// module chunks = 0